import React, { useEffect, useState } from "react";
import propTypes from "prop-types";
import { IAssetVehiclesAtLocationPath, Booking, api, AssetLocationTypes } from "../../../logic/api";
import usePaths from "../../../utility/paths";
import styles from "../styles";
import { useHistory } from "react-router-dom";
import { PagedDataView } from "../../../components/lists/PagedDataView/PagedDataView";
import VehicleLocationListItem from "../../../components/lists/listItems/VehicleLocationListItem/VehicleLocationListItem";
import VehicleRow from "./condensedLayout/vehicle/VehicleRow";
import HeaderRow from "./condensedLayout/HeaderRow";
import { useTranslation } from "react-i18next";
import { ReleaseFlag, useReleaseManagement } from "../../../utility/feature-management";

const VehiclesAtLocation: React.FunctionComponent<{
  isCondensedView?: boolean;
  path: string;
}> = (props) => {
  const paths = usePaths();
  const history = useHistory();
  const { t } = useTranslation();
  const isOpenLinksInNewTab = useReleaseManagement(ReleaseFlag.releaseOpenLinksInNewTabs);

  const allocatedNotPresentReleased = useReleaseManagement(ReleaseFlag.releaseLocationDisplayAllocatedVehicle);

  const [params, setParams] = useState<IAssetVehiclesAtLocationPath>({
    path: props.path
  });

  useEffect(() => {
    if (props.path != params.path) {
      setParams({
        ...params, path: props.path
      });
    }
  }, [props.path]);

  const handleGoToBooking = (bookingId: number) => {
    if (isOpenLinksInNewTab) {
      window.open(paths.booking(bookingId));
    } else {
      history.push(paths.booking(bookingId));
    }
  }

  const isVehicleAllocatedNotPresent = (booking: Booking) => {
    if (allocatedNotPresentReleased) {
      if (
        [AssetLocationTypes.Lane, AssetLocationTypes.Customer].includes(booking.vehicle.location.type)
        && booking.vehicle.allocatedLaneId
        && (!booking.vehicle.location.path.startsWith(props.path))
      ) {
        return true;
      }
    }


    return false;
  }

  return <div style={{ width: "100%" }}>
    {props.isCondensedView ?
      <PagedDataView<IAssetVehiclesAtLocationPath, Booking>
        apiHook={api.hooks.assetVehicle.getAtLocation}
        parameters={params}
        header={() => <HeaderRow columnHeaders={[t("booking.cards.status"), t("booking.labels.ref"), t("locations.location"), t("locations.pos"), t("locations.vehicleReg"), "", t("booking.cards.vehicle"), t("locations.expectedReturn"), ""]} />}
        isTable
        animate={false}
        renderItem={(item, index) => {
          return <VehicleRow booking={item} allocatedNotPresent={isVehicleAllocatedNotPresent(item)} rowIndex={index} onClick={() => handleGoToBooking(item.id)} />
        }}>
        <div style={styles.noData}>
          {t("locations.noVehicles")}
        </div>
      </PagedDataView>
      :
      <PagedDataView<IAssetVehiclesAtLocationPath, Booking>
        apiHook={api.hooks.assetVehicle.getAtLocation}
        parameters={params}
        renderItem={(item) => (
          <VehicleLocationListItem allocatedNotPresent={isVehicleAllocatedNotPresent(item)} booking={item} onClick={() => handleGoToBooking(item.id)} />
        )}
      >
        <div style={styles.noData}>
          {t("locations.noVehicles")}
        </div>
      </PagedDataView>

    }
  </div>
};

VehiclesAtLocation.propTypes = {
  path: propTypes.string.isRequired
}

export default VehiclesAtLocation;
